<template>
  <b-container fluid>
    <b-row>
      <b-col class="col-lg-9" offset="2" style="margin-top: 10px">
        <h2 class="text-left">{{title}}</h2>
        <b-alert :show="loading" variant="info">Bezig met laden...</b-alert>
        <b-alert v-model="errorMessageVisible" variant="danger" dismissible>{{errorMessage}}</b-alert>
      </b-col>
    </b-row>
    <b-row v-if="article">
      <b-col cols="8" offset="2">
        <b-form>
          <b-form-row>
            <b-col cols="3">
              <b-form-group label="Item:"
                            label-for="itemcode"
                            label-cols="2"
                            content-cols="10"
                            style="float:left">
                <b-form-input id="itemcode"
                              v-model="article.itemcode"
                              style="float:left"
                              disabled />
              </b-form-group>
            </b-col>
            <b-col cols="9">
              <b-form-group label="Omschrijving:"
                            label-for="itemdescription"
                            label-cols="4"
                            content-cols="8"
                            style="float:left">
                <b-form-input id="itemdescription"
                              v-model="article.itemdescription"
                              style="float:left"
                              disabled />
              </b-form-group>
            </b-col>
          </b-form-row>
          <div v-if="categoriesLoaded" style="margin-top: 10px">
            <categoryDragDrop v-bind:selectedCategoryList.sync="article.categoriesList"
                              v-bind:unselectedCategoryList.sync="unselectedCategories">
            </categoryDragDrop>
          </div>
          <div class="border articleTranslationStyle">
            <article-translation title="Vertalingen NL"
                                 v-bind:titleShort.sync="article.titleNLD"
                                 v-bind:fullTitle.sync="article.fullTitleNLD"
                                 v-bind:descriptionShort.sync="article.descriptionShortNLD"
                                 v-bind:descriptionLong.sync="article.descriptionLongNLD">
            </article-translation>
          </div>
          <!--TODO: op het moment werkt klikken op labels niet voor onderstaande "article-translations" > Label for "id" verwijst naar de bovenste met die id-->
          <div class="border articleTranslationStyle">
            <article-translation title="Vertalingen DE"
                                 v-bind:titleShort.sync="article.titleDEU"
                                 v-bind:fullTitle.sync="article.fullTitleDEU"
                                 v-bind:descriptionShort.sync="article.descriptionShortDEU"
                                 v-bind:descriptionLong.sync="article.descriptionLongDEU">
            </article-translation>
            </div>
            <div class="border articleTranslationStyle">
              <article-translation title="Vertalingen EN"
                                   v-bind:titleShort.sync="article.titleGBR"
                                   v-bind:fullTitle.sync="article.fullTitleGBR"
                                   v-bind:descriptionShort.sync="article.descriptionShortGBR"
                                   v-bind:descriptionLong.sync="article.descriptionLongGBR">
              </article-translation>
              </div>
              <b-form-row class="mt-3">
                <b-col cols="8" offset="3">
                  <b-button v-on:click="save" variant="primary" :disabled="loading" class="float-right">Opslaan</b-button>
                  <b-button v-on:click="cancel" variant="danger" class="float-right mr-1">Annuleren</b-button>
                </b-col>
              </b-form-row>
            </b-form>
        </b-col>
    </b-row>
  </b-container>
</template>
<script>
  import ErrorHandlerMixin from '@/mixins/ErrorHandlerMixin'
  import ArticleTranslation from '@/components/Articles/ArticleTranslation'
  import CategoryDragDrop from '@/components/Articles/CategoryDragDrop'

  export default {
    name: 'ArticleDetail',
    mixins: [ErrorHandlerMixin],
    data() {
      return {
        title: 'Artikeldetails',
        loading: false,
        article: null,
        unselectedCategories: [],
        categoriesLoaded: false
      }
    },
    components: {
      CategoryDragDrop,
      ArticleTranslation
    },
    created: function () {
      if (this.articleId !== -1) {
        this.loadDetails(this.articleId)
        this.loadCategories(this.articleId)
      }
      else {
        this.article = {}
      }
    },
    props: {
      articleId: Number
    },
    methods: {
      loadDetails(id) {
        this.$api.get('article/' + id)
          .then((response) => {
            this.article = response.data
          })
          .catch((error) => {
            this.article = null

            this.handleHttpError(error, 'Er ging iets fout bij het ophalen van de artikelinformatie.')
          })
      },
      loadCategories(id) {
        this.$api.get('categories/byarticle/' + id)
          .then((response) => {
            this.unselectedCategories = response.data
            this.categoriesLoaded = true
          })
          .catch((error) => {
            this.handleHttpError(error, 'Er ging iets fout bij het ophalen van de categorieën.')
          })
      },
      save() {
        this.loading = true
        this.$api.post('article/', this.article)
          .then(() => {
            this.$router.push({ name: 'articles' })
          })
          .catch((error) => {
            this.handleHttpError(error, 'Er ging iets fout bij het opslaan van de artikeldetails.')
          })
          .finally(() => {
            this.loading = false
          })
      },
      cancel() {
        this.$router.push({ name: 'articles' })
      }
    }
  }
</script>
